"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.decodeUTF8 = decodeUTF8;
exports.encodeUTF8 = encodeUTF8;
exports.toCamelCase = toCamelCase;

/** Turns the first letter of the string to upper case */
function capitalize(str) {
  var _str$0$toUpperCase, _str$;

  return str && typeof str === 'string' ? "".concat((_str$0$toUpperCase = (_str$ = str[0]) === null || _str$ === void 0 ? void 0 : _str$.toUpperCase()) !== null && _str$0$toUpperCase !== void 0 ? _str$0$toUpperCase : '').concat(str.slice(1)) : str;
}
/** Changes any string to camel case */


function toCamelCase(str) {
  // Regex found from https://stackoverflow.com/a/52551910
  return str && typeof str === 'string' ? str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
    return chr.toUpperCase();
  }) : str;
} // Using function overloads (https://www.typescriptlang.org/docs/handbook/2/functions.html#function-overloads)
// in order to have the correct return type based on the input type. (encodeUTF8(string) returns a string and encodeUTF8(null) returns type "null")


function encodeUTF8(str) {
  if (!str) {
    return str;
  }

  var encoded_s = str;

  try {
    encoded_s = encodeURIComponent(str);
  } catch (e) {
    try {
      encoded_s = escape(str);
    } catch (e) {
      encoded_s = str;
    }
  }

  return encoded_s;
}
/**
 * Attempts to decode a given URI component. If the string
 * cannot be decoded, it returns the value as-is.
 *
 * Note: This function does not actually decode UTF8
 * characters. This function is specifically for query
 * string encodings but has been historically misnamed,
 * so we're keeping the same name here for now.
 */
// Function overloads (https://www.typescriptlang.org/docs/handbook/2/functions.html#function-overloads)


function decodeUTF8(str) {
  if (!str) {
    return str;
  }

  try {
    return decodeURIComponent(str);
  } catch (e) {
    try {
      return unescape(str);
    } catch (e) {
      return str;
    }
  }
}